// Styles for DynamicPropertyCard go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledDynamicPropertyCard = styled.div`
  .card-layered {
    border-radius: unset !important;
    box-shadow: unset;
    .t-overline-overlay {
      font-weight: 700;
    }
  }

  .m-badge-overlay-merch {
    color: ${baseVariables.color['base20']};
    background-color: ${baseVariables.color['base10']} !important;
    padding: ${toRem(8)};
  }

  .right-arrow,
  .left-arrow {
    width: fit-content;
  }
  .icon-arrow-left-external:hover::before,
  .icon-arrow-left-external.focus-visible::before {
    transform: rotate(45deg);
    transition: 0.15s all ease-in;
  }
`;
